<!-- Historical games saved from admin-->
<template>
  <section
    id="gameHistory"
    class="section sidearm-mm-game-history-mobile bg-white"
    data-anchor="featured-games"
    scrolling
  >
    <div
      v-touch:swipe.prevent="preventDesktop(swipe)"
      class="slide sidearm-mm-overall-history-mobile relative"
    >
      <section-background css_var="--section-mobile-bg-how-we-got-here"></section-background>
      <div
        class="sidearm-mm-overall-history-mobile__content text-white h-100 overflow-hidden flex flex-column flex-align-stretch relative"
        :class="
          'swipe_direction_' + swipe_direction + ' swipe_step_' + swipe_step
        "
      >
        <transition :name="panel_transition">
          <div
            v-show="swipe_step === 0"
            class="sidearm-mm-overall-history-mobile__intro absolute h-100 w-100 flex flex-column flex-align-start flex-justify-end px-4 pb-8"
          >
            <video-background
              v-if="section.background_type === 'video'"
              :video="section.background_video"
            />
            <div class="relative">
              <h3 v-if="section.title" class="type-hero mb-4">
                {{ section.title }}
              </h3>
              <p v-if="section.sub_title" class="type-paragraph-large ma-0">
                {{ section.sub_title }}
              </p>
              <button @click="moveSlideRight" class="sidearm-mm-btn --ghost relative">
                Pivotal Games <icon> sf-arrows-thick-right --hint</icon>
              </button>
            </div>
          </div>
        </transition>

        <transition :name="panel_transition">
          <div
            v-show="swipe_step === 1 || swipe_step === 2"
            class="sidearm-mm-overall-history-mobile__body-container w-100 h-100 absolute"
          >
            <div
              class="sidearm-mm-overall-history-mobile__body absolute text-white flex flex-column flex-justify-center flex-align-start"
            >
              <p class="type-paragraph-large ma-0 pa-4">
                {{ section.sub_title }}
              </p>
              <div
                class="sidearm-mm-overall-history-mobile__record-items flex flex-align-stretch flex-justify-start flex-wrap text-white relative"
              >
                <div
                  v-for="stat in overall_stats"
                  :key="stat.label"
                  class="sidearm-mm-overall-history-mobile__record-item flex flex-column flex-align-center flex-justify-center w-50 text-center"
                >
                  <div
                    class="sidearm-mm-overall-history-mobile__record-title type-paragraph-regular pb-1"
                  >
                    {{ stat.label }}
                  </div>
                  <div
                    v-if="$root.data"
                    class="sidearm-mm-overall-history-mobile__record-value type-hero-small px-1 text-center"
                  >
                    {{ $root.data.record[stat.key] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition :name="panel_transition">
          <div
            v-show="swipe_step === 3"
            class="sidearm-mm-overall-history-mobile__ad absolute h-100 w-100 flex flex-column flex-justify-center flex-align-center"
          >
            <div>
              <button @click="moveSlideRight" class="sidearm-mm-btn --ghost relative">
                Pivotal Games <icon> sf-arrows-thick-right --hint</icon>
              </button>
              <!-- <img src="https://placehold.it/300x250" /> -->
            </div>
          </div>
        </transition>
      </div>
      <background-element
        class="sidearm-mm-overall-history-mobile__top-background-element  col-1-of-8 absolute"
      />
      <background-element
        class="sidearm-mm-overall-history-mobile__bottom-background-element  col-5-of-8 absolute"
      />
    </div>
    <slide-game-recap
      v-for="(game, game_index) in section.games"
      :key="game.id"
      :game="game"
      :index="game_index + 1"
    />
  </section>
</template>

<script>
import SlideGameRecap from "@/components/Slides/SlideGameRecapMobile";
import BackgroundElement from "@/components/Globals/BackgroundElement";

export default {
  name: "SectionGameHistoryMobileContent",
  components: {
    SlideGameRecap,
    BackgroundElement
  },
  data: () => ({
    overall_stats: [
      { label: "Overall", key: "overall" },
      { label: "Home", key: "home" },
      { label: "Conf", key: "conference" },
      { label: "Away", key: "away" },
      { label: "Streak", key: "streak" },
      { label: "Neutral", key: "neutral" }
    ],
    swipe_step: 0,
    swipe_intervals: 3,
    swipe_direction: "",
    panel_transition: "down"
  }),
  methods: {
    swipe(direction) {
      this.swipe_direction = direction;
      if (direction === "left") {
        this.swipeLeft();
      }
      if (direction === "bottom") {
        this.swipeUp();
      }
      if (direction === "top") {
        this.swipeDown();
      }
    },

    swipeLeft() {
      this.moveSlideRight();
    },

    swipeDown() {
      if (this.swipe_step >= this.swipe_intervals) {
        this.moveSectionDown();
      } else {
        this.panel_transition = "down";
        if (this.swipe_step === 0 && !this.section.sub_title) {
          this.swipe_step++;
        }
        this.swipe_step++;
      }
    },

    swipeUp() {
      if (this.swipe_step === 0) {
        this.moveSectionUp();
      } else {
        this.panel_transition = "up";
        if (this.swipe_step === 2 && !this.section.sub_title) {
          this.swipe_step--;
        }
        this.swipe_step--;
      }
    }
  },

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }

      return this.$root.data.how_we_got_here_section;
    }
  }
};
</script>
<style lang="scss">
.sidearm-mm-game-history-mobile {
  .fp-slidesNav {
    @include reset-slides-nav;
    opacity: 1;
    transition: opacity 0.7s;
    pointer-events: none;
    &.fp-bottom {
      bottom: auto;
      top: $header-height-mobile;
    }
    ul {
      display: flex;
      width: 100%;
      margin: 0;
      justify-content: flex-end;
      padding-top: $spacer * 2;
      li {
        padding-right: 12px;
        position: relative;
        overflow: hidden;
        pointer-events: all;
        &:first-child {
          display: none;
        }
        &:last-child {
          display: block;
        }
        &::after {
          position: absolute;
          top: 50%;
          left: calc(1.5rem);
          width: 100%;
          height: 1px;
          content: "";
          border-top: dashed 1px $color-white;
        }
        a {
          margin-right: 0;
          transition: margin 0.3s;
          &.active {
            margin-right: 12px;
            span {
              border: dashed 1px $color-white;
              width: 100%;
              height: 100%;
            }
          }
          span {
            border: solid 3px $color-white;
            transition: border 0.3s, width 0.3s, height 0.3s;
          }
        }
      }
    }
  }
}

body.fp-viewing-featured-games-0,
body.fp-viewing-featured-games-featured-games-end {
  .sidearm-mm-game-history-mobile {
    .fp-slidesNav {
      opacity: 0;
    }
  }
}

.sidearm-mm-fullscreen {
  top: 0;
  left: 0;
}
</style>
<style lang="scss" scoped>
.sidearm-mm-overall-history-mobile {
  &__divider {
    z-index: 1;
    > span {
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }
    &--start {
      &::before {
        width: calc(100% - 1.5rem);
        height: 1px;
        position: absolute;
        top: 50%;
        left: 1.5rem;
        content: "";
        background: $color-white;
      }
      &::after {
        width: 1px;
        height: calc(50% + #{$header-height});
        position: absolute;
        bottom: 50%;
        right: 0;
        content: "";
        background-color: $color-white;
      }
    }
    &--end {
      width: 60px;
      top: calc(50% + #{$header-height/2});
      right: 0;
      transform: translateY(-50%);
      &::before {
        position: absolute;
        top: 50%;
        left: 1.5rem;
        height: 1px;
        width: calc(100% - 1.5rem);
        content: "";
        background: $color-white;
      }
      &::after {
        width: 400px;
        height: 1px;
        position: absolute;
        top: 50%;
        left: 100%;
        content: "";
        background: $color-black;
      }
    }
  }
  &__top-background-element {
    top: $header-height;
    left: 0;
    height: calc((100% - #{$header-height}) * 0.375);
    z-index: 1;
  }
  &__bottom-background-element {
    bottom: 0;
    right: 0;
    height: calc(100% - #{$header-height});
    z-index: 1;
  }
  &__content {
    z-index: 2;
  }
  &__intro {
    top: 0;
    left: 0;
  }
  &__body-container {
    top: 0;
    left: 0;
  }
  &__body {
    bottom: 0;
    left: 0;
    transform: translateY(calc(60vh - #{$header-height-mobile}));
    transition: transform 0.4s;
  }
  &__record-items {
    width: 100%;
    padding: 0 $spacer * 4;
    height: calc(100vh - #{$header-height-mobile});
    transition: padding 0.4s;
  }
  &__record-item {
    background: rgba(0, 0, 0, 0.5);
    padding: #{grid_percent(60)};
  }
  &__ad {
    top: 0;
    left: 0;
    padding-top: $header-height-mobile;
  }
}

.sidearm-mm-overall-history-mobile__content {
  &.swipe_step_2,
  &.swipe_step_3 {
    .sidearm-mm-overall-history-mobile__body {
      transform: none;
    }

    .sidearm-mm-overall-history-mobile__record-items {
      padding: 0;
    }
  }
}
.sidearm-mm-game-history {
  &__transition {
    position: relative;
    z-index: 2;
  }
  &__transition-divider {
    &::before {
      position: absolute;
      top: calc(50% + #{$header-height/2});
      right: 0;
      width: 100%;
      height: 1px;
      content: "";
      background: $color-black;
    }
    &::after {
      height: calc(50% - #{$header-height/2});
      position: absolute;
      width: 1px;
      bottom: 0;
      right: 0;
      content: "";
      background-color: $color-black;
    }
  }
}

.up-enter-active,
.up-leave-active {
  transition: all 0.5s ease;
}
.up-enter {
  transform: translateY(-25%);
  opacity: 0;
}
.up-leave-to {
  transform: translateY(25%);
  opacity: 0;
}

.down-enter-active,
.down-leave-active {
  transition: all 0.5s ease;
}
.down-enter {
  transform: translateY(25%);
  opacity: 0;
}
.down-leave-to {
  transform: translateY(-25%);
  opacity: 0;
}
</style>
